import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Select from 'react-select';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { setCurrencyFormat } from '../../../../utils/helpers';
import { sortType } from '../../helper';

import {
  getAdvSalesData,
  handleLoader
}
  from '../../../../redux/actions/advSalesAction';
import ShowAdvSales from './ShowAdvSales';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';


const AdvSales = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const { advSalesData, salesChannelFilterData, isLoading } = useSelector(
    ({ advSalesReducer, marketPlaceReducer }) =>
    ({
      advSalesData: advSalesReducer.advSalesData,
      isLoading: advSalesReducer.isLoading,
      salesChannelFilterData: marketPlaceReducer.salesChannel,

    })
  );

  const previousMonthDate = new Date();
  previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

  const [advSalesDataToShow, setDataToShow] = useState([])
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [selectedCampaignOptions, setselectedCampaignOptions] = useState();
  const [fromDate, setFromDate] = useState(previousMonthDate);
  const [toDate, setToDate] = useState(new Date());

  const campaignTypeOptions = [];
  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  // eslint-disable-next-line array-callback-return
  advSalesData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
    data.filterData.forEach((element) => {
      campaignTypeOptions.push({
        value: element.key,
        label: element.shortValue
      });
    });
  });

  const sortedCampaignTypeOptions = campaignTypeOptions.sort((a, b) => a.label > b.label ? 1 : -1)

  // eslint-disable-next-line react/prop-types
  const changeFilterForCampaignType = (value) => {
    setselectedCampaignOptions(value)
  };

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartV = document.getElementById('dvChartView');
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Advertising Sales Report ${new Date().getFullYear()}`,
    })
    dvChartV.style.display = "block"; 
  }

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
        flag = false
      }
    }
    return flag
  }

  const callApi = () => {
    dispatch(handleLoader(true));
    dispatch(getAdvSalesData(
      {
        fromdate: moment(fromDate).format('YYYY-MM-DD'),
        todate: moment(toDate).format('YYYY-MM-DD')
      }
    ));
  }

  const handleApplyDate = () => {
    callApi()
  }  

  useEffect(() => {
    dispatch(handleLoader(true));
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setDataToShow(advSalesData?.modal?.data || []);
  }, [advSalesData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  let dataToShowForDatesSelected = advSalesDataToShow?.filter(item => filterBasedOnFilter(item))
  if (selectedCampaignOptions?.length) {
    const selected = selectedCampaignOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    dataToShowForDatesSelected = dataToShowForDatesSelected.
    filter(item => selected[item.campaignType])
  }
  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
        disabled={!dataToShowForDatesSelected.length}
      >
        View Report
      </button>
    </div>
  )

  const thisMonthData = {};
  dataToShowForDatesSelected.forEach((item) => {
    const monthDayYear = moment(item.date).format('MM-DD-YYYY')
    if (item.date && thisMonthData[monthDayYear]) {
      thisMonthData[monthDayYear].push(item)
    } else {
      thisMonthData[monthDayYear] = [item]
    }

  })

  //   const max = currentMonthDayCount > prevMonthDayCount ? currentMonthDayCount : prevMonthDayCount;
  const reduceCallback = (acc, item) => acc + Number(item.advSales)
  const reduceCallbackForTotalSales = (acc, item) => acc + Number(item.totalSales)
  const reduceCallbackForTotalSpend = (acc, item) => acc + Number(item.spend)
  const dataToPlot = []

  Object.keys((thisMonthData)).forEach((dayMonthYear) => {
    const totalAdvSales = thisMonthData?.[dayMonthYear].reduce(reduceCallback, 0)
    const totalSales = thisMonthData?.[dayMonthYear].reduce(reduceCallbackForTotalSales, 0)
    const totalSpend = thisMonthData?.[dayMonthYear].reduce(reduceCallbackForTotalSpend, 0)
    const aCOS = ((totalSpend * 100) / totalAdvSales).toFixed(2);
    dataToPlot.push({
      "day": dayMonthYear,
      'Sales': totalSales.toFixed(2),
      'AdvSales': totalAdvSales.toFixed(2),
      'Spend': totalSpend.toFixed(2),
      'ACOS': aCOS
    })
  })

  const dataToShowForExcel = [];
  const tableHeader = [
    {
      Header: "Day",
      accessor: "day",
      disableGlobalFilter: false,
      width: 120,
      sortType
    },
    {
      Header: "Sales",
      accessor: "Sales",
      disableGlobalFilter: false,
      width: 120,
      rightAlign: true,
      sortType
    },
    {
      Header: "AdvSales",
      accessor: "AdvSales",
      disableGlobalFilter: false,
      width: 120,
      rightAlign: true,
      sortType
    },
    {
      Header: "ACOS",
      accessor: "ACOS",
      disableGlobalFilter: false,
      width: 120,
      rightAlign: true,
      sortType
    },
    {
      Header: "Spend",
      accessor: "Spend",
      disableGlobalFilter: false,
      width: 120,
      rightAlign: true,
      sortType
    }
  ];

  dataToPlot?.forEach((dataValue, index) => {
    const subData = {}
    subData.day = dataValue?.day;
    subData.Sales = setCurrencyFormat(dataValue?.Sales, true);
    subData.AdvSales = setCurrencyFormat(dataValue?.AdvSales, true);
    subData.ACOS = `${setCurrencyFormat(dataValue?.ACOS, false)} %`;
    subData.Spend = setCurrencyFormat(dataValue?.Spend, true);
    dataToShowForExcel.push(subData)
  });

  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">Advertising Sales</h5>
              </div>
              <Row className="align-items-center">
                <Col sm="3" md="10">
                  <Row className="align-items-center">
                    <Col sm="3">
                      <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Date</span>
                        <div className="form__form-group-field">
                          <div className="date-picker">
                            <DatePicker
                              className="form__form-group-datepicker"
                              selected={moment(fromDate).toDate()}
                              showPreviousMonths
                              onChange={handleFromDateChange}
                              dateFormat="MM/dd/yyyy"
                              dropDownMode="select"
                              popperPlacement="center"
                              withPortal={isMobileOnly}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm="3">
                      <div className="form__form-group mb-0">
                        <span className="form__form-group-label">To Date</span>
                        <div className="form__form-group-field">
                          <div className="date-picker">
                            <DatePicker
                              className="form__form-group-datepicker"
                              selected={moment(toDate).toDate()}
                              onChange={handleToDateChange}
                              dateFormat="MM/dd/yyyy"
                              dropDownMode="select"
                              popperPlacement="center"
                              withPortal={isMobileOnly}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm="3" style={{ top: '10px' }}>
                      <button className="btn btn-sm btn-primary apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button>
                        <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                    </Col> 
                    <Col sm="1">
                    &nbsp;
                    </Col>                   
                      <Col sm="2">
                      <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Filter Type</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedCampaignOptions}
                        options={sortedCampaignTypeOptions}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-300"
                        onChange={changeFilterForCampaignType}
                        classNamePrefix="react-select"
                        isMulti
                      />
                    </div>

                  </div>
                      </Col>
                  </Row>
                </Col>

              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
            <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <ShowAdvSales
                  title="Adv Sales"
                  viewReportButton={viewReportButton}
                  data={dataToShowForDatesSelected}
                  dir={rtl.direction}
                />}
            </div>
          </div>
        </CardBody>
      </Card>
      </div>
      <ViewSalesReportModal
        modalData={dataToShowForExcel}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        title="Adv Sales Report"
        fileName="Adv Sales Report"
      />
    </Container>
  );
};

AdvSales.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(AdvSales)